import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { AppState } from 'src/app/store/app.state';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { loginSuccess } from 'src/app/store/actions/auth.actions';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup;

  ngUnsubscribe = new Subject()
  
  show: boolean = false;
  errorMessage: string = '';

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private router: Router,
    private authService: AuthService,
    private modalService: ModalService,
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    })
  }

  login(){
    this.errorMessage = '';

    const payload = {
      username: this.username?.value,
      password: this.password?.value,
    }

    this.authService.logIn(payload).toPromise().then((res) => {
      // The API now returns the token and user data in the body for all roles.
      if(res?.details?.token){
        // Dispatch to store so interceptors and guards can use it.
        // We also store it in a cookie as a fallback for the interceptor.
        this.cookieService.set('token', res.details.token, 1, '/', undefined, true, 'None');

        this.store.dispatch(loginSuccess({
          data: res.details.user,
          tempUserSession: { accessToken: res.details.token }
        } as any));

        this.modalService.hideLogin();
        this.router.navigateByUrl('/admin/home');
      }
    }).catch((error) => {
      const msg = error?.error?.message || 'Login failed. Please try again.';
      this.errorMessage = msg;
      console.log({error})
    })
  }

  get username(){
    return this.form.get('username');
  }

  get password(){
    return this.form.get('password');
  }

  showPassword() {
    this.show = !this.show;
  }
}
